import { createFileRoute, redirect } from '@tanstack/react-router';
import { FEE_RATE_BASE_PATH } from '../../../../../../../../features/fees/fee-rate/fee-rate-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/')({
  beforeLoad: () => {
    throw redirect({ to: FEE_RATE_BASE_PATH });
  },
  preload: false,
});
